(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ax-product-focus-apparel"] && !Shopify.designMode) return;
  try {
    
	const ouvrirAvis = (comportement) => {
		const details = document.querySelector('.ax-focus-apparel__item--reviews');
		if (!details) return false;
		details.open = true;
		details.scrollIntoView({ behavior: comportement, block: 'start' });
		return true;
	};

	document.addEventListener('click', (event) => {
		const lien = event.target.closest?.('a[href="#avis-verifies"]');
		if (lien && ouvrirAvis('smooth')) event.preventDefault();
	});

	if (location.hash === '#avis-verifies') ouvrirAvis('auto');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  // Le <details> du sélecteur de langue ne se referme pas seul : ni au clic
  // ailleurs, ni à Échap. On aligne son comportement sur celui du menu déroulant
  // de devise, qui lui le fait.
  const closeLanguageSelectors = (except) => {
    for (const details of document.querySelectorAll('.ax-language-selector[open]')) {
      if (details === except) continue;
      details.open = false;
    }
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    closeLanguageSelectors(target?.closest('.ax-language-selector'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const open = document.querySelector('.ax-language-selector[open]');
    if (!open) return;

    closeLanguageSelectors();
    open.querySelector('summary')?.focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
